<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_74abb6de"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    id="p-progressSpinner_4b694f90"
  ></p-progressSpinner>
</div>

<main class="new-builds-landing-page">
  <header class="hero-section">
    <img
      src="/assets/img/search-landing-header.png"
      alt="New car builds image"
      class="hero-image"
    />
    <div class="hero-content">
      <h1 class="hero-title">new car builds</h1>
      <p class="hero-description">
        TrinityRail is a leading manufacturer of railcars in North America. Our
        emphasis on quality, craftsmanship, and superior customer service,
        combined with our broad product portfolio and manufacturing flexibility,
        position us to meet our customers' needs. We offer more than 100 railcar
        models, which we frequently customize to customer requirements.
      </p>
    </div>
  </header>

  <section class="main-content">
    <nav class="tab-navigation">
      <p-tabView>
        <p-tabPanel
          [header]="CAR_TYPE.COVERED_HOPPER | titlecase"
          [selected]="true"
          (click)="loadData(CAR_TYPE.COVERED_HOPPER)"
        >
          <div *ngIf="loadedData === CAR_TYPE.COVERED_HOPPER">
            <div class="section-header">
              <h2 class="section-title">Covered Hoppers</h2>
              <button
                class="quote-button"
                [class.disabled]="quoteControl.disabled"
                [disabled]="quoteControl.disabled"
                (click)="beginQuoteRequest()"
              >
                {{ quoteControl?.value }}
              </button>
            </div>

            <p class="section-description">
              To begin a quote, select the product and railcar type to the left.
              You will have an opportunity to provide mechanical options and
              leasing criteria on the following pages.
            </p>
            <div class="product-grid">
              <article
                class="product-card"
                *ngFor="let product of products; trackBy: trackByModelId"
              >
                <header class="product-header">
                  <h3 class="product-type">{{ 'new car build' }}</h3>
                  <div
                    class="select-btn"
                    (click)="toggleSelect(product)"
                    id="div_select-btn"
                  >
                    <div
                      class="selected-btn"
                      *ngIf="product.isSelected; else unselected"
                      id="div_selected-btn"
                    >
                      <span id="span_selected">Selected</span>
                      <img
                        class="selected-icon"
                        src="../../../assets/icons/checkmark-icon.svg"
                        alt="Checkmark Icon"
                        title="Checkmark Icon"
                        aria-label="Checkmark Icon"
                        id="img_selected-icon"
                      />
                    </div>
                    <ng-template #unselected>
                      <div
                        class="unselected-btn"
                        [ngClass]="
                          selectEnabled ? 'select-enabled' : 'select-enabled'
                        "
                        id="div_unselected-btn"
                      >
                        <span id="span_unselected">Select</span>
                      </div>
                    </ng-template>
                  </div>
                </header>
                <img
                  [src]="getImageUrl(product.file_name)"
                  [alt]="product?.model_desc"
                  class="product-image"
                />
                <h4 class="product-title">{{ product?.model_desc }}</h4>
                <p class="product-description" [title]="product.car_overview">
                  {{ truncateText(product.car_overview, 100) }}
                </p>
                <p class="product-pricing">
                  {{
                    product?.rate
                      ? '$' + product?.rate
                      : 'Pricing available upon request'
                  }}
                </p>
                <a (click)="openModel(product)" class="product-link"
                  >Learn more</a
                >
              </article>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel
          [header]="CAR_TYPE.PRESSURE_TANK | titlecase"
          [disabled]="isDisabled"
          (click)="loadData(CAR_TYPE.PRESSURE_TANK)"
        >
          <div *ngIf="loadedData === CAR_TYPE.PRESSURE_TANK">
            <p>Coming Soon</p>
          </div>
        </p-tabPanel>

        <p-tabPanel
          [header]="CAR_TYPE.GONDOLA | titlecase"
          [disabled]="isDisabled"
          (click)="loadData(CAR_TYPE.GONDOLA)"
        >
          <div *ngIf="loadedData === CAR_TYPE.GONDOLA">
            <p>Coming Soon</p>
          </div>
        </p-tabPanel>
      </p-tabView>
    </nav>

    <section class="pricing-info">
      <h3 class="pricing-info-title">Pricing & Availability</h3>
      <p class="pricing-info-description">
        Prices shown are base railcar estimates, are not guaranteed, and are
        subject to change based on specific customer requirements including, but
        not limited to, intended commodity usage, railcar modifications and
        freight or other costs. Railcars displayed in search results are based
        on TrinityRail® available inventory at time of search and subject to
        change. Total or partial railcar groupings are not guaranteed. Specific
        pricing and railcar details will be provided during the quoting process.
        All prices shown are in USD.
      </p>
    </section>
  </section>
</main>

<p-dialog
  [(visible)]="isDisplayingDialog"
  [draggable]="false"
  [modal]="true"
  [dismissableMask]="true"
  [showHeader]="false"
  [focusTrap]="false"
  (onHide)="closeModel()"
  position="top"
  maskStyleClass="detail-dialog"
  id="p-dialog_1ca03474"
>
  <ng-container
    *ngIf="isDisplayingDialog && !!detailViewObj"
    id="ng-container_179fbb42"
  >
    <app-new-builds-learn-more
      (closeNewModelFn)="closeModel()"
      (selectedCar)="carSelected($event)"
      [carDetails]="detailViewObj"
    ></app-new-builds-learn-more>
  </ng-container>
</p-dialog>
